export default __webpack_public_path__ + "static/media/team-1-2.465790e6.jpg";